import { render, staticRenderFns } from "./ImagesSetting.vue?vue&type=template&id=12a4c3ee&"
import script from "./ImagesSetting.vue?vue&type=script&lang=js&"
export * from "./ImagesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports